import { useState, useEffect } from 'react'
import { Building2, Car, Settings, ParkingCircle } from 'lucide-react'
import api from '../services/api'
import {
  PageHeader,
  Card,
  CardBody,
  FormSelect,
  EmptyState
} from '../components/common'
import ParkingSpots from './ParkingSpots'
import ParkingConfiguration from './ParkingConfiguration'
import ParkingOccupancy from './ParkingOccupancy'

const TABS = [
  { id: 'spots', label: 'Parking Spots', icon: Car },
  { id: 'configuration', label: 'Configuration', icon: Settings },
  { id: 'occupancy', label: 'Occupancy', icon: ParkingCircle },
]

const Parking = () => {
  const [buildings, setBuildings] = useState([])
  const [selectedBuildingId, setSelectedBuildingId] = useState('')
  const [activeTab, setActiveTab] = useState('spots')

  useEffect(() => {
    loadBuildings()
  }, [])

  const loadBuildings = async () => {
    try {
      const response = await api.get('/Building', { params: { pageNumber: 1, pageSize: 200 } })
      const items = response.data.items || []
      setBuildings(items)
      if (items.length > 0) {
        setSelectedBuildingId(items[0].id)
      }
    } catch (err) {
      console.error('Error loading buildings:', err)
    }
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Parking Management"
        subtitle="Manage parking spots, configuration, and occupancy"
      />

      <Card>
        <CardBody>
          <FormSelect
            label="Building"
            value={selectedBuildingId}
            onChange={(e) => setSelectedBuildingId(e.target.value)}
            options={[
              { value: '', label: 'Select a building...' },
              ...buildings.map(b => ({ value: b.id, label: b.name || b.userName }))
            ]}
          />
        </CardBody>
      </Card>

      {!selectedBuildingId ? (
        <EmptyState
          icon={Building2}
          title="Select a building"
          description="Choose a building from the dropdown to manage its parking."
        />
      ) : (
        <>
          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              {TABS.map((tab) => {
                const isActive = activeTab === tab.id
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 py-3 px-1 border-b-2 text-sm font-medium transition-colors ${
                      isActive
                        ? 'border-primary-500 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <tab.icon className="w-4 h-4" />
                    {tab.label}
                  </button>
                )
              })}
            </nav>
          </div>

          {/* Tab Content */}
          {activeTab === 'spots' && <ParkingSpots buildingId={selectedBuildingId} />}
          {activeTab === 'configuration' && <ParkingConfiguration buildingId={selectedBuildingId} />}
          {activeTab === 'occupancy' && <ParkingOccupancy buildingId={selectedBuildingId} />}
        </>
      )}
    </div>
  )
}

export default Parking
